import { createFileRoute } from '@tanstack/react-router'
import NotFoundPage from '#/pages/NotFoundPage'

export const Route = createFileRoute('/_home/404')({
  head: () => ({
    meta: [
      {
        title: "404 - Page Not Found | Wa'allamah",
      },
    ],
  }),
  component: () => <NotFoundPage />,
})
